{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "בוחר הצבעים",
  "colorSwatch": "דוגמית צבע",
  "transparent": "שקוף",
  "twoDimensionalSlider": "מחוון דו מימדי"
}
